(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-card-add-form]');
      if (!form || typeof window.addToCart !== 'function') return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const message = form.querySelector('[data-card-add-error]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      message.hidden = true;
      try {
        await window.addToCart([{
          id: Number(form.elements.id.value),
          quantity: Number(form.elements.quantity.value)
        }]);
      } catch {
        message.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-discount')) {
    customElements.define('newsletter-discount', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const input = this.querySelector('[data-discount-code]');
        const button = this.querySelector('[data-copy-discount]');
        const status = this.querySelector('[data-copy-status]');
        button.addEventListener('click', async () => {
          button.disabled = true;
          status.textContent = '';
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = this.dataset.copied;
          } catch {
            input.focus();
            input.select();
            input.setSelectionRange(0, input.value.length);
            status.textContent = this.dataset.copyFailed;
          } finally {
            button.disabled = false;
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-whatsapp-contact-link]');
      if (!link) return;
      const url = new URL(link.href);
      let message = link.dataset.message || '';
      if (link.dataset.includePage === 'true') {
        message = [message, document.title, window.location.href].filter(Boolean).join('\n');
      }
      url.searchParams.set('text', message);
      link.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
